export default {
    props: {
        class: 'mr-2 ml-2',
        style: { width: '760px' },
        breakpoints:{ '960px': '85vw', '641px': '98vw' },
        modal: true,
        draggable: false,
    },
}
